<template>
  <wrapLogin @loginedClick="_toOrderList">
    <div class="consult-expert-list-to-order-btn">
      <icon name="dingdan1" />我的订单
    </div>
  </wrapLogin>
</template>

<script>
import wrapLogin from 'app/web/component/consult/wrapLogin.vue'
export default {
  components: {
    wrapLogin
  },
  methods: {
    _toOrderList() {
      this.routerPush(
        `https://static.xinli001.com/msite/index.html#/consult-list-user`
      )
    }
  }
}
</script>

<style lang="scss">
.consult-expert-list-to-order-btn {
  position: fixed;
  right: 0;
  bottom: 120px;
  margin-bottom: constant(safe-area-inset-bottom);
  // background-image: linear-gradient(90deg, #3ab0ff, #54c8ff);
  background: #718aff;
  border-radius: 40px 0 0 40px;
  width: 180px;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: #ffffff;
  z-index: 2;

  .icon-node-website {
    font-size: 27px;
    margin-right: 5px;
  }
}
</style>
